import React, { Component } from "react";
// react component for creating dynamic tables
import ReactTable from "react-table";
import {
    Row,
    Col,
    Grid,
    FormGroup,
    FormControl,
    ControlLabel,
    Tooltip,
    OverlayTrigger
} from "react-bootstrap";

import Card from "../../components/Card/Card.jsx";
import Button from "../../components/CustomButton/CustomButton.jsx";
import SweetAlert from 'react-bootstrap-sweetalert';

import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';
import * as loginActions from '../../actions/loginActions';
import * as clauseActions from '../../actions/clauseActions';
import rest from "../../API/api";
//import {readTenantSuccess} from "../../actions/tenantActions";


class ClauseReactTables extends Component {
    constructor(props) {
        super(props);
        this.props.clauseActions.loadClauses(this.props.userLoggedIn[0]);
        //debugger;
        this._load_rows = this._load_rows.bind(this);
        this._edit_clause = this._edit_clause.bind(this);
        this._delete_clause = this._delete_clause.bind(this);
        this._deleteClauseAlert = this._deleteClauseAlert.bind(this);
        this.state = {
            alert: null
        }

        //console.log(data.authenticated);
        //console.log(data.admin);
        //console.log('parsed json', data);
        //data.map(user => console.log(user.fname));
        //Check to see if the user authenticated
    }

    static get contextTypes() {
        return {
            router: PropTypes.object
        };
    }


    _deleteClauseAlert(id){
        //console.log("email to delete:" + email);
        this.setState({
            alert: (
                <SweetAlert
                    warning
                    showCancel
                    confirmBtnText="Yes, delete it!"
                    confirmBtnBsStyle="danger"
                    cancelBtnBsStyle="default"
                    title="Are you sure?"
                    style={{display: "block"}}
                    onConfirm={() => this._delete_clause(id)}
                    onCancel={() => this.setState({alert: null})}
                >
                    Are you sure you want to delete this clause?
                </SweetAlert>
            )
        });
    }

    _edit_clause(id){
        //debugger;
        //Grab the current record from MongoDB and update the store via the reducer using the Thunk in customerActions.js
        this.props.clauseActions.readClause(this.props.userLoggedIn[0],id);
    }
    _delete_clause(id){
        //console.log("email to delete:" + email);
        //lets call the customerActions.js thunk function to delete this customer record
        this.props.clauseActions.deleteClause(this.props.userLoggedIn[0],id);
        //call SweetAlerts and confirm that the customer was deleted successfully
    }

    _load_rows(){
        //debugger;
        this.state = {
            data: this.props.clauses.map((clause, i) => {
                return {
                    id: clause._id,
                    Type: clause.Type,
                    Required: clause.Required,
                    Title: clause.Title,
                    Text: clause.Text,
                    actions: (
                        // we've added some custom button actions
                        <div className="actions-right">
                            {/* use this button to add a record */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"add_" + i}>Add New Clause</Tooltip>}>
                                <span>
                            <Button
                                onClick={async () => {
                                    let obj = this.state.data.find(o => o.id === clause._id);
                                    let tURL = "/addclause";
                                    await this.context.router.history.push(tURL);
                                }}
                                bsStyle="info"
                                simple
                                icon
                            >
                                <i className="fa fa-plus"/>
                            </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* use this button to add a edit kind of action */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"edit_" + i}>Edit Clause</Tooltip>}>
                                <span>
                            <Button
                                onClick={ async () => {
                                    let obj = this.state.data.find(o => o.id === clause._id);
                                    //Open the form to edit the after we have updated the store with the customer
                                    //that we want to edit, this way the form can read the store and load the customer
                                    //record for editing from the Redux Store
                                    let tURL = "/editclause/" + obj.id;
                                    await this.context.router.history.push(tURL);
                                }}
                                bsStyle="info"
                                simple
                                icon
                            >
                                <i className="fa fa-edit"/>
                            </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {/* use this button to remove the data row */}
                            <OverlayTrigger placement="top" overlay={<Tooltip id={"delete_" + i}>Delete Clause</Tooltip>}>
                                <span>
                            <Button
                                onClick={() => {
                                    var data = this.state.data;
                                    data.find((o, i) => {
                                        if (o.id === clause._id) {
                                            //pass the id to delete to handler so it can be passed to
                                            //tenantActions.js thunk for store update
                                            this._deleteClauseAlert(o.id);
                                            return true;
                                        }
                                        return false;
                                    });
                                    this.setState({data: data});
                                }}
                                bsStyle="danger"
                                simple
                                icon
                            >
                                <i className="fa fa-times"/>
                            </Button>{" "}
                                </span>
                            </OverlayTrigger>
                            {this.state.alert}
                        </div>
                    )
                };
            })
        };
    }


    render() {
        //debugger;
        //console.log(this.props.customer);
        this._load_rows();
        if ((this.props.userLoggedIn[0].status) && (this.props.userLoggedIn[0].subscription)) {
            return (
                <div className="main-content" style={{ backgroundImage: "url(" + require("../../assets/img/matrix.jpg") + ")" }}>
                    <Grid fluid>
                        <Row>
                            <Col md={12}>
                                <Card
                                    title="Our Clauses"
                                    content={
                                        <ReactTable
                                            data={this.state.data}
                                            filterable
                                            columns={[
                                                {
                                                    Header: "Title",
                                                    accessor: "Title"
                                                },
                                                {
                                                    Header: "Required",
                                                    accessor: "Required"
                                                },
                                                {
                                                    Header: "Type",
                                                    accessor: "Type",
                                                },
                                                {
                                                    Header: "Text",
                                                    accessor: "Text"
                                                },
                                                {
                                                    Header: "Actions",
                                                    accessor: "actions",
                                                    sortable: false,
                                                    filterable: false
                                                }
                                            ]}
                                            defaultPageSize={10}
                                            showPaginationTop
                                            showPaginationBottom={false}
                                            className="-striped -highlight"
                                        />
                                    }
                                />
                            </Col>
                        </Row>
                    </Grid>
                </div>
            )

        }
        else {
            alert("You must be logged in and have an active subscription to access this page!");
            this.context.router.history.push("/pages/login-page");
            return(null);
        }

    }
}



ClauseReactTables.propTypes = {
    loginActions: PropTypes.object.isRequired,
    userLoggedIn: PropTypes.array.isRequired,
    clauses: PropTypes.array.isRequired,
    clause: PropTypes.object.isRequired
};

function mapStateToProps(state, ownProps) {
    //debugger;
    return {
        userLoggedIn: state.userLoggedIn,
        clauses: state.clauses,
        clauset: state.clause
    };
}

function mapDispatchToProps(dispatch) {
    return {
        loginActions: bindActionCreators(loginActions, dispatch),
        clauseActions: bindActionCreators(clauseActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ClauseReactTables);

//export default ReactTables;



// WEBPACK FOOTER //
// ./src/views/Tables/ClausesTable.jsx